import { isDesktop } from 'react-device-detect';
import BonusGameFinishedController from '../../controllers/bonus/BonusGameFinishedController';
import MainGridController from '../../controllers/grid/MainGridController';
import { COMPONENTS } from '../../lib/constants';
import { BonusGameFinishedGridView } from './BonusGameFinishedGridView';
let scale = isDesktop ? 1 : 2;
export const BonusGameFinishedView = {
	name: COMPONENTS.BONUS_GAME_FINISHED_DIALOGUE,
	child: true,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: BonusGameFinishedController,
			name: BonusGameFinishedController,
			config: {
				item: 'bonus_game_finished_wrapper',
				val: 'bonus_game_finished_wrapper'
			}
		},
		{
			Controller: MainGridController,
			name: 'bonusgamegridController',
			config: BonusGameFinishedGridView
		}
	],
	components: [
		{
			name: 'bonus_game_finished_wrapper',
			type: 'Sprite',
			components: [
				{
					name: 'bg',
					type: 'Sprite',
					img: 'congrats_screen',
					position: { x: 0, y: 0 },
					scale: { x: scale, y: scale }
				},
				{
					name: 'text',
					type: 'CustomText',
					text: 'BONUS_ROUND_FINISHED_HEADER',
					position: { x: 1137 / 2 + 10, y: 100 },
					anchor: { x: 0.5, y: 0.5 }
				},
				{
					name: 'text_1',
					type: 'Text',
					text: 'BONUS_ROUND_FINISHED_TEXT',
					position: { x: 1137 / 2, y: 180 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'text_2',
					type: 'CustomText',
					text: 'BONUS_ROUND_FINISHED_WINAMOUNT',
					position: { x: 1137 / 2 + 10, y: 330 },
					anchor: { x: 0.5, y: 0.5 }
				},
				{
					name: 'text_3',
					type: 'CustomText',
					text: 'BONUS_ROUND_FINISHED_TOTAL',
					position: { x: 1137 / 2 + 10, y: 480 },
					anchor: { x: 0.5, y: 0.5 }
				},
				{
					name: 'text_4',
					type: 'Text',
					text: 'BONUS_ROUND_FINISHED_NOTE',
					position: { x: 1137 / 2, y: 540 },
					anchor: { x: 0.5, y: 0 }
				}
			]
		}
	]
};
